import {Component} from '@angular/core';

@Component({
    selector: 'app-general-body-meeting',
    templateUrl: './general-body-meeting.component.html',
    styleUrl: './general-body-meeting.component.css'
})
export class GeneralBodyMeetingComponent {

}
